<div class="holder">
  <div class="range" #range="" [ngClass]='"bg-"+bgTemplate'>
    <div class="marker" #slider="">
      <img *ngIf="value >= 0" [src]='"/assets/images/progress-"+value+".png"' [attr.data-index]="value" [ngClass]="{ 'anim-zoom': enableAnimation }" />
    </div>
  </div>
</div>
<div class="stages" *ngIf="fraction">
  <span *ngFor="let item of stages; let i = index" [ngStyle]='{"width": fraction + "px"}' [ngClass]='{ "active": i == value }'>{{item}}</span>
</div>